require('angular')
require("angular-bootstrap")
require('../../../core/translation/translation-module')

RecommendModal = require('./recommend-pc-modal.jade')
RecommendModalCtrl = require("./recommend-modal-controller.coffee")

modules = [
  'ui.bootstrap'
  'gnp-translation'
]

angular.module 'gnp-modal', modules
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'RecommendModalCtrl', RecommendModalCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/modal/modal-module.coffee